/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDentalSurface } from 'app/shared/model/dental-surface.model';
import { IDentalMouthItem } from 'app/shared/model/dental-mouth-item.model';
import { ErotionType } from 'app/shared/model/enumerations/erotion-type.model';

export interface IDentalSurfaceErosion {
  id?: string;
  erotionType?: keyof typeof ErotionType;
  score?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  surface?: IDentalSurface | null;
  mouthItem?: IDentalMouthItem | null;
}

export const defaultValue: Readonly<IDentalSurfaceErosion> = {
  active: false,
};
